// extracted by mini-css-extract-plugin
export default {"circle":"Cursor_circle__539u8"};